import { useEffect } from "react";

import { getTooltipPosition } from "../../../utils/getTooltipPosition";
import Tooltip from "../../Tooltip/Tooltip";

import { ErrorTooltipContent } from "./ErrorTooltipContent";

import type React from "react";

import "./styles.scss";

interface ErrorTooltipProps {
  error?: string | null;
  targetElement?: HTMLElement | null;
  isFieldFocused: boolean;
  children: React.ReactNode;
  showTooltip: boolean;
  setShowTooltip: (isOpen: boolean) => void;
}

export const ErrorTooltip = ({
  targetElement,
  error,
  children,
  isFieldFocused,
  showTooltip,
  setShowTooltip,
}: ErrorTooltipProps): JSX.Element => {
  useEffect(() => {
    // update tooltip position on scroll
    let timeoutId: ReturnType<typeof setTimeout>;

    const handleScroll = () => {
      clearTimeout(timeoutId);
      setShowTooltip(false);
      timeoutId = setTimeout(() => {
        if (targetElement?.matches(":focus")) {
          setShowTooltip(true);
        }
      }, 500);
    };

    if (error && isFieldFocused) {
      window.addEventListener("scroll", handleScroll, true);
    }

    return () => {
      clearTimeout(timeoutId);
      window.removeEventListener("scroll", handleScroll);
    };
  }, [isFieldFocused, error]);

  return (
    <Tooltip
      targetElement={targetElement}
      parentTitle
      anchorElement="target"
      position="bottom"
      updateInterval={100}
      content={() => <ErrorTooltipContent text={error} />}
      tooltipClassName="error-tooltip"
      className={error ? "error-tooltip" : "error-tooltip-hidden"}
      showCallout={false}
      open={!!error && showTooltip}
      onPosition={getTooltipPosition}
    >
      {children}
    </Tooltip>
  );
};

export default ErrorTooltip;
